import { DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '@tdwb/core';
export class EservicesAnalytics {
  static taggingEvents: DataAnalyticsTaggingEvents = {
    pageEservicesRegisteredStatements: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'statements',
        subSection1: 'registered',
        subSection2: 'statements',
        customPageName: 'wb_account-registered-statements',
        tabName: 'tdw:wbt:tabs:statements'
      }
    },
    pageEservicesRegisteredConfirmations: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'confirmations',
        subSection1: 'registered',
        subSection2: 'confirmations',
        customPageName: 'wb_account-registered-confirmations',
        tabName: 'tdw:wbt:tabs:confirmations'
      }
    },
    pageEservicesRegisteredTax_Documents: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'tax-documents',
        subSection1: 'registered',
        subSection2: 'tax-documents',
        customPageName: 'wb_account-registered-tax-documents',
        tabName: 'tdw:wbt:tabs:tax documents'
      }
    },
    pageEservicesRegisteredCorporate_Actions: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'corporate-actions',
        subSection1: 'registered',
        subSection2: 'corporate-actions',
        customPageName: 'wb_account-registered-corporate-actions',
        tabName: 'tdw:wbt:tabs:corporate actions'
      }
    },
    pageEservicesRegisteredPreferences: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'preferences',
        subSection1: 'registered',
        subSection2: 'preferences',
        customPageName: 'wb_account-registered-preferences',
        tabName: 'tdw:wbt:tabs:delivery preferences'
      }
    }
  }
}
